"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VizRest = function () {
  function VizRest($http) {
    (0, _classCallCheck3.default)(this, VizRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      VIZ_DETAIL: 'viz/%1$s/axis/'
    };
  }

  (0, _createClass3.default)(VizRest, [{
    key: "getVizAxis",
    value: function getVizAxis(kind) {
      return this.$http.get(this.sprintf(this.PATH.VIZ_DETAIL, kind));
    }
  }]);
  return VizRest;
}();

exports.default = VizRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/VizResource.js
// module id = 333
// module chunks = 0